import { Badge, Box, Grid, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import CustomSelect from "../../../../../Components/CustomSelect";
import DataService from "../../../../../Service";
import DashboardChartService from "./DashboardChartService";
import SettingsIcon from "@material-ui/icons/Settings";
import { makeStyles } from "@material-ui/core";
import moment from "moment";
import { Button } from "@material-ui/core";
import { Popover } from "@material-ui/core";
import { DateRange } from "react-date-range";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import GetAppIcon from "@material-ui/icons/GetApp";
import ChartLoader from "./ChartLoader";
import React from "react";

const useStyles = makeStyles((theme) => ({
  datePicker: {},
  datepickerPopover: {
    boxShadow: "0px 0px 0px 7px #fff",
    textAlign: "right",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },
  selectClients: {
    "& .MuiSelect-select": {
      padding: "5px 8px !important",
    },
  },
}));
function Clients(props) {
  const { isManageInfo } = props;
  props.setLoader(false);
  const data = {
    labels: [],
    datasets: [
      {
        label: "Number of clients",
        maxBarThickness: 30,
        data: [],
        backgroundColor: [
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
        ],
        borderColor: [
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
          "#3868A5",
        ],
        borderWidth: 1,
      },
    ],
  };
  const topClientData = {
    labels: [],
    datasets: [
      {
        label: "Program price",
        maxBarThickness: 30,
        data: [],
        backgroundColor: [
          "#40bac6",
          "#40bac6",
          "#40bac6",
          "#40bac6",
          "#40bac6",
          "#40bac6",
        ],
        borderColor: [
          "#40bac6",
          "#40bac6",
          "#40bac6",
          "#40bac6",
          "#40bac6",
          "#40bac6",
        ],
        borderWidth: 1,
      },
    ],
  };

  const revenueData = {
    labels: [],
    datasets: [
      {
        label: "Annual revenue",
        maxBarThickness: 30,
        data: [],
        backgroundColor: [
          "#086e99",
          "#086e99",
          "#086e99",
          "#086e99",
          "#086e99",
          "#086e99",
        ],
        borderColor: [
          "#086e99",
          "#086e99",
          "#086e99",
          "#086e99",
          "#086e99",
          "#086e99",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        align: "end",
        labels: {
          boxWidth: 25,
          padding: 15,
        },
      },
    },
    scales: {
      y: {
        min: 0,
        // max: 18,
        ticks: {
          stepSize: 2,
        },
        grace:"50%",
      },
    },
  };
  const classes = useStyles();
  // For first Graph
  const [userData, setUserData] = useState({
    client: "by type",
    avgDurationPeriod: "Last 6 months",
    avgDurationYear:"",
    avgDurationYearEnd:"",
  });
  console.log(userData,"user Data")
  const [chartData, setChartData] = useState({});
  const [currentChartData, setCurrentChartData] = useState(data);
  const [currentChartDataArr, setCurrentChartDataArr] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = useState({});

  // For Second Graph
  const [topFiveChartData, setTopFiveChartData] = useState(topClientData);

  // For Revenue Graph
  const [revenueChartData, setRevenueChartData] = useState(revenueData);

  const [filterDataState, setFilterDataState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [anchorElPicker, setAnchorElPicker] = useState(null);
  const [chartLoader, setChartLoader] = useState({
    client: true,
    topClient: true,
    anualrevenu: true,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  useEffect(() => {
    getClientData();
    getTopFiveClientData();
    getRevenueData(userData.avgDurationPeriod);
  }, []);

  useEffect(() => {
    if (
      filterDataState[0]?.startDate !== filterDataState[0]?.endDate ||
      (filterDataState[0]?.startDate === "" &&
        filterDataState[0]?.endDate === "")
    ) {
      // getRevenueData(userData.avgDurationPeriod);
      let params={}
      if(filterDataState[0]?.startDate !== ""){
      params = {
        from_date:  moment(filterDataState[0]?.startDate).format("MMM") + " " + moment(filterDataState[0]?.startDate).year() ,
        end_date :  moment(filterDataState[0]?.endDate).format("MMM") + " " + moment(filterDataState[0]?.endDate).year()
        }}
      getTopFiveClientData(params);
      setAnchorElPicker(null);
    }
  }, [filterDataState]);

  const getClientData = () => {
    DataService.getData({}, "dashboards_fetch_clients_data").then(
      (response) => {
        setChartData(response);
        afterSelectClintType(response[userData.client]);
      }
    );
  };

  const getTopFiveClientData = (queryParams) => {
    let params = {from_date:queryParams?.from_date,end_date:queryParams?.end_date}
    DataService.getData({...params},"client_dashboards_top_five_clients").then(
      (response) => {
        setTopFiveChartData((prev)=>{
          const updatedTopFiveData = { ...prev };
          updatedTopFiveData.datasets[0].data = Object.values(response.data);
          updatedTopFiveData.labels = Object.keys(response?.data); 
          console.log(updatedTopFiveData.datasets[0].data,prev.datasets[0].data,"data changing")
          return updatedTopFiveData;      
        }) ;       
        setChartLoader((pev) => ({
          ...pev,
          topClient: false,
        }));
      }
    );
  };

  const getRevenueData = (avgDurationPeriod,year,endYear) => {
    const { startDate, endDate } = filterDataState[0];
    var pdata = "?filter=" + avgDurationPeriod || "";
    const params ={
      filter:avgDurationPeriod ||"",
      start_year:year,
      end_year:endYear||year
    }
    // if (year) {
    //   pdata = pdata + "&start_year=" + year;
    // }

    // // if (endDate) {
    // //   pdata = pdata + "&end_year=" + moment(endDate).format("YYYY");
    // // }
    DataService.getDirectData(
      "client_dashboards/annual_revenue" ,
      params
    ).then((response) => {
      const updatedRevenueData = { ...revenueChartData };
      updatedRevenueData.datasets[0].data = Object.values(response.data);
      updatedRevenueData.labels = Object.keys(response.data);
      setRevenueChartData(updatedRevenueData);
      setChartLoader((pev) => ({
        ...pev,
        anualrevenu: false,
      }));
    });
  };

  const handleClickPicker = (event) => {
    setAnchorElPicker(event.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorElPicker(null);
  };

  const openPicker = Boolean(anchorElPicker);
  const id = openPicker ? "simple-popover" : undefined;

  const onChangeItem = (selectedItemValue) => {
    setUserData((prev)=>{
      return {...prev,
        [selectedItemValue.id]: selectedItemValue.value,
    }});
    console.log(selectedItemValue,"selected")
    if (selectedItemValue.id === "client") {
      setChartLoader((pev) => ({
        ...pev,
        client: true,
      }));
      selectedItemValue.value &&
        afterSelectClintType(chartData[selectedItemValue.value]);
    }
    if (selectedItemValue.id === "avgDurationPeriod") {
      setUserData((prev)=>{
        return {...prev,
        avgDurationYear: "",
        avgDurationYearEnd:""
      }});
      setChartLoader((pev) => ({
        ...pev,
        anualrevenu: true,
      }));
      getRevenueData(selectedItemValue.value,"","");
    }
    if(selectedItemValue.id === "avgDurationYear"){
      setUserData((prev)=>{
        return {...prev,
        avgDurationPeriod: "",
      }});
      setChartLoader((pev) => ({
        ...pev,
        anualrevenu: true,
      }));
      getRevenueData("",selectedItemValue.value,userData.avgDurationYearEnd);
    }if(selectedItemValue.id === "avgDurationYearEnd"){
      setUserData((prev)=>{
        return {...prev,
        avgDurationPeriod: "",
      }});
      setChartLoader((pev) => ({
        ...pev,
        anualrevenu: true,
      }));
      getRevenueData("",userData.avgDurationYear,selectedItemValue.value);
    }
    
  };

  const afterSelectClintType = (obj) => {
    const pdata = {};
    obj.map((option, i) => (pdata[option.name] = i < 7 ? true : false));
    setChecked({ ...checked, ...pdata });

    const newChartData = JSON.parse(JSON.stringify({ ...currentChartData }));

    newChartData.datasets[0].data = obj
      .map((option, i) => i < 7 && option.value)
      .filter((option) => option !== false);
    newChartData.labels = obj
      .map((option, i) => i < 7 && option.name)
      .filter((option) => option !== false);

    setCurrentChartData(newChartData);
    setCurrentChartDataArr(
      obj.map((option, i) =>
        i < 7
          ? { name: option.name, checked: true, value: option.value }
          : { name: option.name, checked: false, value: option.value }
      )
    );
    setChartLoader((pev) => ({
      ...pev,
      client: false,
    }));
  };

  const afterUpdateGraph = (objArr, checkedArr) => {
    const newChartData = JSON.parse(JSON.stringify({ ...currentChartData }));

    const filteredCurrentChartDataArr = objArr.filter(
      (option) => option.checked
    );
    newChartData.datasets[0].data = filteredCurrentChartDataArr.map(
      (option, i) => option.value
    );
    newChartData.labels = filteredCurrentChartDataArr.map(
      (option, i) => option.name
    );
    setCurrentChartData(newChartData);
    setChecked(checkedArr);
    handleClose();
    setChartLoader((pev) => ({
      ...pev,
      client: false,
    }));
  };
  const presentYear=new Date().getFullYear();
const yearRangeArr = new Array(50).fill(1).map(((el,ind)=>{
     return (presentYear-ind).toString();
}))
console.log(topFiveChartData.datasets[0].data,"year range")
  return (
    <Grid>
      <Box
        style={{
          position: "sticky",
          top: isManageInfo ? "168px" : "120px",
          backgroundColor: "#fff",
          zIndex: 2,
          padding: "16px 0px 0 16px",
          boxShadow: "0px -7px 0px 7px #ffffff",
        }}
      >
        <Grid container xs={12}>
          <Grid item xs={8}></Grid>

          <Grid item xs={2}>
            {" "}
            <Box>
              {/* <Button
                disableElevation
                style={{
                  backgroundColor: "#077f83",
                  color: "#fff",
                  textTransform: "none",
                  float: "right",
                  marginRight: 10,
                }}
              >
                <SettingsIcon
                  style={{ marginRight: 10, fontSize: 14, cursor: "pointer" }}
                />
                Customize view
              </Button> */}
            </Box>
          </Grid>
          {/* <Grid item xs={2}>
            <Box>
              <Button
                disableElevation
                style={{
                  backgroundColor: "#EF7000",
                  color: "#fff",
                  textTransform: "none",
                  // marginLeft: "2px"
                  // float: 'right'
                }}
              >
                <GetAppIcon style={{ marginRight: 10, fontSize: 14 }} />
                Download xls
              </Button>
            </Box>
          </Grid> */}
        </Grid>
        <br />
        <Grid item xs={12}>
          
        </Grid>
      </Box>
      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Clients
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <CustomSelect
                      className={classes.selectClients}
                      id="client"
                      displayEmpty
                      hideLable
                      variant="outlined"
                      itemArr={[
                        "by type",
                        "by delivery location",
                        "by industry sector",
                        "by panel",
                        "by service categories",
                        "by source",
                        "by status",
                        "by type of contract",
                      ]}
                      parentcall={onChangeItem}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                      defaultValue={userData.client}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Box textAlign="center">
                      <Badge color="primary" onClick={handleClickOpen}>
                        <SettingsIcon style={{ cursor: "pointer" }} />
                      </Badge>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box width={1}>
              {chartLoader.client ? (
                <ChartLoader />
              ) : (
                <BarChart
                  currentChartData={currentChartData}
                  options={options}
                />
              )}
            </Box>
            {open && (
              <DashboardChartService
                currentChartDataArr={currentChartDataArr}
                setCurrentChartDataArr={setCurrentChartDataArr}
                afterUpdateGraph={afterUpdateGraph}
                open={open}
                handleClose={handleClose}
                grpahChecked={checked}
              />
            )}
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={6}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "47px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Box
                    fontWeight="fontWeightBold"
                    style={{ marginLeft: "26px" }}
                  >
                    Top most 5 clients
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={6}>
              <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            {filterDataState[0]?.startDate ? (
              <AddCircleIcon
                onClick={() => {
                  setFilterDataState([
                    {
                      key: "selection",
                      startDate: "",
                      endDate: "",
                    },
                  ]);
                }}
                fontSize="large"
                color="error"
                style={{
                  cursor: "pointer",
                  transform: "rotate(45deg)",
                  marginRight: "10px",
                }}
              />
            ) : null}
            <div className={classes.datepickerPopover}>
              <Button
                aria-describedby={id}
                variant="contained"
                onClick={handleClickPicker}
              >
                {/* {filterDataState[0]?.startDate
                  ? moment(filterDataState[0]?.startDate).format("Do MMM YYYY")
                  : "DD MM YYYY"}{" "}
                -{" "}
                {filterDataState[0]?.endDate
                  ? moment(filterDataState[0]?.endDate).format("Do MMM YYYY")
                  : "DD MM YYYY"} */}
                {filterDataState[0]?.startDate
                  ? moment(filterDataState[0]?.startDate).format("DD/MM/YYYY")
                  : "DD/MM/YYYY"}{" "}
                -{" "}
                {filterDataState[0]?.endDate
                  ? moment(filterDataState[0]?.endDate).format("DD/MM/YYYY")
                  : "DD/MM/YYYY"}
              </Button>
              <Popover
                id={id}
                open={openPicker}
                anchorEl={anchorElPicker}
                onClose={handleClosePicker}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "center",
                  horizontal: "center",
                }}
              >
                <DateRange
                  className={classes.datePicker}
                  editableDateInputs={true}
                  onChange={(item) => {
                    setFilterDataState([item.selection]);
                  }}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDataState}
                  startDatePlaceholder="Start date"
                  endDatePlaceholder="End date"
                  dateDisplayFormat="dd/MM/yyyy"
                />
              </Popover>
            </div>
          </div>
              </Grid>
            </Grid>
            <Box width={1}>
              <Box width={1}>
                {console.log("runnning with data",topFiveChartData.datasets[0].data)}
                {chartLoader.topClient ? (
                  <ChartLoader />
                ) : (
                  <TopClientBar
  currentChartData={topFiveChartData}
  options={options}
  />
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={3} style={{ marginTop: "0.75rem" }}>
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={4}>
                    <Typography variant="subtitle1" color="secondary">
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Annual revenue
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={4} style={{display:"flex",justifyContent:"space-evenly"}}>
                    <CustomSelect
                      className={classes.selectClients}
                      style={{width:"90%"}}
                      variant="outlined"
                      id="avgDurationYear"
                      // hideLable
                      labelText="Start year"
                      // placeHolder="Start year"
                      parentcall={onChangeItem}
                      itemArr={yearRangeArr}
                      defaultValue={userData.avgDurationYear||""}
                      displayEmpty
                    />
                    <CustomSelect
                      className={classes.selectClients}
                      style={{width:"90%"}}
                      variant="outlined"
                      id="avgDurationYearEnd"
                      // hideLable
                      disabled={userData.avgDurationYear === ""}
                      labelText="End year"
                      placeHolder="year"
                      parentcall={onChangeItem}
                      itemArr={yearRangeArr.filter((el)=>{return Number(el)>Number(userData.avgDurationYear) })}
                      defaultValue={userData.avgDurationYearEnd||""}
                      displayEmpty
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <CustomSelect
                      className={classes.selectClients}
                      variant="outlined"
                      id="avgDurationPeriod"
                      hideLable
                      parentcall={onChangeItem}
                      itemArr={["Last 6 months", "Last 12 months"]}
                      defaultValue={userData.avgDurationPeriod || ""}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box width={1}>
              {chartLoader.anualrevenu ? (
                <ChartLoader />
              ) : (
                <RevenueBar
                  currentChartData={revenueChartData}
                  options={options}
                />
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Clients;

const NotFoundFallback = () => {
  return (
    <Box
      style={{
        width: "100%",
        height: "23.5rem",
        maxHeight: "23.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        component={"p"}
        style={{ fontWeight: 800, fontSize: "1.1rem" }}
      >
        Data not found
      </Typography>
    </Box>
  );
};

const BarChart = React.memo(
  (props) => {
    const dataLength = props?.currentChartData.datasets[0].data.length;
    const labelLength = props?.currentChartData.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            id={"client"}
            data={props?.currentChartData}
            options={props?.options}
            fallbackContent="Data not found"
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },

  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.currentChartData) ===
      JSON.stringify(nextProps.currentChartData)
    );
  }
);

const TopClientBar =
  (props) => {
    console.log(props.currentChartData?.datasets[0].data,"props")
    const dataLength = props?.currentChartData?.datasets[0].data.length;
    const labelLength = props?.currentChartData?.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            id="top_five_clients"
            data={props?.currentChartData}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  };

const RevenueBar = React.memo(
  (props) => {
    const dataLength = props.currentChartData.datasets[0].data.length;
    const labelLength = props.currentChartData.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            id="revenue"
            data={props.currentChartData}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.currentChartData) ===
      JSON.stringify(nextProps.currentChartData)
    );
  }
);
